// CMS-side featured images come back as relative paths ("uploads/foo.jpg")
// while the static fallback uses bare filenames ("1.webp") that live under
// /img/product-3/. Rewrite CMS paths to absolute URLs against the admin base
// so every image load works, and leave static-fallback paths untouched.
const CMS_API_BASE =
  process.env.CMS_API_BASE ||
  process.env.NEXT_PUBLIC_CMS_API_BASE ||
  "http://localhost:8000";

export const resolveProductImage = (raw) => {
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith("/")) return raw;
  if (raw.startsWith("uploads/")) {
    return `${CMS_API_BASE.replace(/\/$/, "")}/${raw.replace(/^\/+/, "")}`;
  }
  // Static fallback — bare filename like "1.webp" → /img/banner/project-banner.webp
  return `/img/product-3/${raw}`;
};
